import { lazy } from 'react';
import paths from '../paths';
import { createLazyComponent, createRoute } from 'constants/utils';

const ProductEditLayout = lazy(() => import('../../components/layout/product/ProductEditLayout'));
const BundleEditLayout = lazy(() => import('../../components/layout/product/BundleEditLayout'));
const Product = lazy(() => import('../../components/pages/product/products'));
const Bundles = lazy(() => import('../../components/pages/product/bundles'));
const AddProduct = lazy(() => import('../../components/pages/product/editProducts/AddProduct'));
const Variants = lazy(() => import('../../components/pages/product/editProducts/variant/Variants'));
const EditBundle = lazy(() => import('../../components/pages/product/editBundles/EditBundle'));
const ProductSettings = lazy(() => import('../../components/pages/product/settings/ProductSettings'));

export const productRoutes = (abilities) => {
  return [
    {
      path: paths.getProductLayout,
      children: [
        (abilities?.product?.read ?? false) && createRoute(paths.products, Product),
        (abilities?.product_bundle?.read ?? false) && createRoute(paths.bundles, Bundles),
        (abilities?.vertical?.read ?? false) && createRoute(paths.productSettings, ProductSettings),
      ].filter(Boolean),
    },
    {
      path: paths.getProductEditLayout(),
      element: createLazyComponent(ProductEditLayout),
      children: [
        (abilities?.product?.write ?? false) && createRoute(paths.editProduct(), AddProduct),
        (abilities?.product?.read ?? false) && createRoute(paths.variants(), Variants),
      ].filter(Boolean),
    },
    {
      path: '/product/bundles/:id',
      element: createLazyComponent(BundleEditLayout),
      children: [
        (abilities?.product?.write ?? false) && createRoute('edit', EditBundle),
      ].filter(Boolean),
    },
  ].filter(Boolean);
};
